import { render, staticRenderFns } from "./AmsTable.vue?vue&type=template&id=ba7adce8&scoped=true&"
import script from "./AmsTable.vue?vue&type=script&lang=js&"
export * from "./AmsTable.vue?vue&type=script&lang=js&"
import style0 from "./AmsTable.vue?vue&type=style&index=0&id=ba7adce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7adce8",
  null
  
)

export default component.exports